<template>
  <v-dialog v-model="show">
    <v-card>
      <v-card-text>
        <v-text-field
          label="Ссылка на Youtube-видео"
          v-model="url"
        ></v-text-field>
        <v-text-field label="Ширина" v-model="width"></v-text-field>
        <v-text-field label="Высота" v-model="height"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel">Отмена</v-btn>
        <v-btn text @click="ok">ОК</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean
  },
  data() {
    return {
      show: false,
      url: "",
      width: "480",
      height: "320",
      command: null
    };
  },
  computed: {
    youtubeID() {
      return this.youtubeParser(this.url);
    }
  },
  methods: {
    open(command) {
      this.command = command;
      this.show = true;
    },
    close() {
      this.show = false;
    },
    cancel() {
      this.close();
    },
    ok() {
      const data = {
        command: this.command,
        data: {
          src: "https://www.youtube.com/embed/" + this.youtubeID,
          width: parseInt(this.width),
          height: parseInt(this.height)
        }
      };

      this.$emit("onConfirm", data);
      this.close();
    },
    youtubeParser(url) {
      // const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = url.match(regExp);
      return match && match[7].length === 11 ? match[7] : false;
    }
  }
};
</script>
